import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SessionStorage, SessionStorageService } from "ngx-webstorage";
import { SiniestralidadDiagnostico, RankingDiagnosticos, SiniestralidadDependientes } from "../entities/vam_entities";

@Component({
    selector: 'SiniestralidadDiagnostico',
    templateUrl: 'detalle-diagnosticogr.template.html'
})
export class DetalleDiagnosticoComponentGr implements OnInit {
    public lineChartLabels: Array<any>;
    public reembolsoDiagChartData: Array<any>;
    public numReclamosDiagChartData: Array<any>;
    public lineChartLabelsReembolso: Array<any>;
    public mayorReembolsoDiagChartData: Array<any>;
    public mayorNumReclamosDiagChartData: Array<any>;

    @Input('rankingDiagnosticosGr')
    diagnosticosXReclamo: RankingDiagnosticos;
    topDiagnosticoReclamo: SiniestralidadDiagnostico[];
    detalleDiagnosticoReclamo: SiniestralidadDiagnostico[];
    dependientes: SiniestralidadDependientes[];
    diagnosticoMayorValor: SiniestralidadDiagnostico[];
    detalleDiagnosticoMayorValor: SiniestralidadDiagnostico[];
    dependientesMayorValor: SiniestralidadDependientes[];

    public lineChartOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    id: 'yAxis1',
                    position: 'left'
                },
                {
                    id: 'yAxis2',
                    position: 'right'
                }
            ]
        }
    };
    public lineChartLegend: boolean = true;
    public lineChartType: string = 'line';
    public lineChartColors: Array<any> = [
        { // grey
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        { // dark grey
            backgroundColor: 'rgba(77,83,96,0.2)',
            borderColor: 'rgba(77,83,96,1)',
            pointBackgroundColor: 'rgba(77,83,96,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(77,83,96,1)'
        },
    ];


    constructor() {

        this.diagnosticosXReclamo = new RankingDiagnosticos();
        this.topDiagnosticoReclamo = [];
        this.detalleDiagnosticoReclamo = [];
        this.dependientes = [];
        this.lineChartLabels = new Array<any>();
        this.reembolsoDiagChartData = new Array<any>();
        this.numReclamosDiagChartData = new Array<any>();
        this.diagnosticoMayorValor = [];
        this.lineChartLabelsReembolso = new Array<any>();
        this.mayorReembolsoDiagChartData = new Array<any>();
        this.mayorNumReclamosDiagChartData = new Array<any>();
        this.detalleDiagnosticoMayorValor= [];
        this.dependientesMayorValor = [];
    }

    ngOnInit(): void {

        this.lineChartLabels = new Array<any>();
        this.reembolsoDiagChartData = new Array<any>();
        this.numReclamosDiagChartData = new Array<any>();
        this.lineChartLabelsReembolso = new Array<any>();
        this.mayorReembolsoDiagChartData = new Array<any>();
        this.mayorReembolsoDiagChartData = new Array<any>();
    }

    ngOnChanges(): void {
     
        if (this.diagnosticosXReclamo != undefined && this.diagnosticosXReclamo != null) {
            this.topDiagnosticoReclamo = this.diagnosticosXReclamo.DiagnosticosXReclamos;
            if (this.topDiagnosticoReclamo != undefined) {
                let diagnosticos: Array<any>;
                diagnosticos = new Array<any>();
                for (let i = 1; i <= this.topDiagnosticoReclamo.length; i++) {
                    diagnosticos.push(i);
                }

                this.lineChartLabels = diagnosticos;
                let reembolso: Array<any> = this.topDiagnosticoReclamo.map(data => data.ValorReembolsado);
                let siniestros: Array<any> = this.topDiagnosticoReclamo.map(data => data.NumeroReclamos);
                this.reembolsoDiagChartData = [{ data: reembolso, label: 'Valor Reembolsado', yAxisID:"yAxis1" }, { data: siniestros, label: 'Número de Reclamos', yAxisID:"yAxis2" }];
            }
            if (this.diagnosticosXReclamo.DetalleDiagnosticosXReclamos != undefined) {
                this.dependientes = this.diagnosticosXReclamo.DetalleDiagnosticosXReclamos.TipoDependiente;
                this.detalleDiagnosticoReclamo = this.diagnosticosXReclamo.DetalleDiagnosticosXReclamos.TipoPaciente;
            }

            if (this.diagnosticosXReclamo != undefined && this.diagnosticosXReclamo != null) {
                if(this.diagnosticosXReclamo.DiagnosticosMayorValor!= undefined && this.diagnosticosXReclamo.DiagnosticosMayorValor != null){
                    this.diagnosticoMayorValor = this.diagnosticosXReclamo.DiagnosticosMayorValor;
                    if (this.diagnosticoMayorValor != undefined && this.diagnosticoMayorValor.length > 0) {
                        let diagnosticos: Array<any>;
                        diagnosticos = new Array<any>();
                        for (let i = 1; i <= this.diagnosticoMayorValor.length; i++) {
                            diagnosticos.push(i);
                        }
    
                        this.lineChartLabels = diagnosticos;
                        let reembolso: Array<any> = this.diagnosticoMayorValor.map(data => data.ValorReembolsado);
                        let siniestros: Array<any> = this.diagnosticoMayorValor.map(data => data.NumeroReclamos);
                        this.mayorReembolsoDiagChartData = [{ data: reembolso, label: 'Valor Reembolsado', yAxisID:"yAxis1" }, { data: siniestros, label: 'Número de Reclamos', yAxisID:"yAxis2" }];
                    }
                }
               
                if (this.diagnosticosXReclamo.DetalleDiagnosticosMayorValor != undefined && this.diagnosticosXReclamo.DetalleDiagnosticosMayorValor != null) {
                    this.dependientesMayorValor = this.diagnosticosXReclamo.DetalleDiagnosticosMayorValor.TipoDependiente;
                    this.detalleDiagnosticoMayorValor = this.diagnosticosXReclamo.DetalleDiagnosticosMayorValor.TipoPaciente;
                }
            }
            
        }
    }

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/polizasContratadas/detalle-diagnosticogr.componet.ts